// 過大画像は端末内で縮小して処理を続行する（要件 2.3）。
// 上限長辺は背景除去のメモリ・処理時間の実測に基づき調整する
export const MAX_SOURCE_EDGE = 2048;

export interface DownscalePlan {
  width: number;
  height: number;
  downscaled: boolean;
}

export function planDownscale(
  width: number,
  height: number,
  maxEdge: number = MAX_SOURCE_EDGE,
): DownscalePlan {
  const longEdge = Math.max(width, height);
  if (longEdge <= maxEdge || longEdge === 0) {
    return { width, height, downscaled: false };
  }
  const ratio = maxEdge / longEdge;
  return {
    width: Math.max(1, Math.round(width * ratio)),
    height: Math.max(1, Math.round(height * ratio)),
    downscaled: true,
  };
}
